




















































































import { Component, Prop, Vue } from "vue-property-decorator";

interface Post {
  uid: string
  title: string
  content: string
  createdAt: string
  tags: Array<string>
  image: string
}

interface Description {
  id: string;
  title: string;
  descriptions: Array<Td>;
}
interface Td {
  id: string;
  title: string;
  images: Array<Image>;
  items: Array<string>;
  pres: Array<Pre>;
}

interface Image {
  src: string;
  comment: string;
}
interface Pre {
  src: string;
  comment: string;
}

@Component
export default class SignupComponent extends Vue {
  @Prop()
	private msg!: string;
	private signinStatus = "signed out"

	private isActive = "1"

	private mailaddress: string = ''
	private password: string = ''

	created() {
		const user = this.$auth.currentUser
		if (user) {
			// User is signed in.
			const email = user.email
			const uid = user.uid
			this.signinStatus = "signed in"
			//window.console.log("created() 2.User is signed in: ")
			//window.console.log("created() 3.uid: " + uid)
			//window.console.log("created() 4.email: " + email)
		} else {
			// No user is signed in.
			this.signinStatus = "signed out"
			window.console.log("created() 5.No user is signed in: ")
			// 単純な遷移
			//this.$router.push('/signin/')
		}
	}

	public test() {
		window.console.log("test() 1.this.$watanabe: " + this.$watanabe)
		this.$watanabe = "多賀恵"
		const user = this.$auth.currentUser

		if (user) {
			// User is signed in.
			const email = user.email
			const uid = user.uid
			window.console.log("test() 2.User is signed in: ")
			window.console.log("test() 3.uid: " + uid)
			window.console.log("test() 4.email: " + email)
		} else {
			// No user is signed in.
			window.console.log("test() 3.No user is signed in: ")
		}
		window.console.log("test() 4.this.$watanabe: " + this.$watanabe)
	}

	public signout() {
		window.console.log("signout() 1.");
		this.$auth.signOut()
		window.alert('サインアウトしました。')
	}
	
	public signin() {
		//window.console.log("signin() 1.this.mailaddress: " + this.mailaddress);
		//window.console.log("signin() 2.this.password: " + this.password);
		//window.console.log("signin() 3.this.$watanabe: " + this.$watanabe);
		
		this.$auth.signInWithEmailAndPassword(this.mailaddress, this.password)
		.then((user) => {
			// 成功時の処理
			window.console.log("signin() 3.成功");
			const currentUser = this.$auth.currentUser;
        	// E-Mailの確認が取れていない場合は強制サインアウト
        	if (!currentUser!.emailVerified) {
				currentUser!.sendEmailVerification().then(() => {
					window.alert('まだログインできておりません。確認メールをお送りしますので返信をお願いします。')
					// 確認のE-Mail送信に成功
					// この時点ではE-Mailアドレスの所有権が
					// 確認されていないため、強制的にサインアウトします。
					// （サービスの利用はできない）
					this.$auth.signOut()
					window.console.log("signin() 4.メール確認のため、強制サインオフ");
	        	})
	        	.catch((error) => {
					// 確認のE-Mail送信でエラー（エラー処理）        	
					var errorCode = error.code;
					var errorMessage = error.message;
					window.console.log("signin() 5.確認のE-Mail送信でエラー errorMessage: " +  + errorMessage);
	        	})
        	} else {
				window.alert('メールを確認しました。サインインに成功しました。')
				this.$watanabe = "多賀恵"

				window.console.log("signin() 6.成功 this.$watanabe: " + this.$watanabe);
        	}
		})
		.catch((error) => {
			// エラー時の処理 
			var errorCode = error.code;
			var errorMessage = error.message;
			window.console.log("signin() 7.サインイン失敗 errorMessage: " + errorMessage);
		})
		this.mailaddress = "";
		this.password = "";
	}

  private contents1: Description = {
  	id: "1",
  	title: "メールリンクを使用して Firebase 認証を行う",
  	descriptions: [
  	 {id: "1",
  	  title: "Firebase プロジェクトでメールリンク ログインを有効にする",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"1.Firebase コンソールで [Authentication] セクションを開きます。",
  	  	"2.[Sign-in method] タブで [メール / パスワード] を有効にします。",
  	  	"メールリンク ログインを使用するには、メール / パスワードによるログインを有効にする必要があります。",
  	  	"3.同じセクションで、ログイン方法として [メールリンク（パスワードなしでログイン）] を有効にします。",
  	  	"4.[保存] をクリックします。",
  	    ],
	  pres: [],
  	 }, // end of id=1
  	 {id: "2",
  	  title: "ユーザーのメールアドレスに認証リンクを送信する",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"TODO",
  	    ],
	  pres: [],
  	 }, // end of id=2
  	 {id: "3",
  	  title: "メールリンク ログインを完了する",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"TODO",
  	    ],
	  pres: [],
  	 }, // end of id=3
  	 {id: "4",
  	  title: "メール / パスワードとメールリンクを区別する",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"TODO",
  	    ],
	  pres: [],
  	 }, // end of id=4
  	 {id: "5",
  	  title: "次のステップ",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"TODO",
  	  ],
	  pres: [],
  	 }, // end of id=5

  	]
  } // end of contents1
  
} // end of export
